import { DEVICE_TYPES, MODELS, TRAITS, hasTrait, isModel, isType } from "../../../constants/devices";

// Routes of the device settings pages. Each page takes the device as
// location.state.data.
export const SETTINGS_PATHS = Object.freeze({
  COMMON: "/device-settings/common",
  POWER: "/device-settings/power",
  MOTOR: "/device-settings/motor",
  CURTAIN: "/device-settings/curtain",
  VACUUM: "/device-settings/vacuum",
  SECURITY: "/device-settings/security",
  METER: "/device-settings/energy-meter",
  METER_ALARMS: "/device-settings/energy-meter/alarms",
});

// The page the detail screen's cog opens, or null when the device has none.
// Same rules, in the same order, as the app's action icons
// (app/screens/CommonSwichDetails.js). Power settings open from the common page.
export const settingsPathFor = (device) => {
  if (!device) return null;
  if (isType(device, DEVICE_TYPES.WATER_LEVEL_CONTROLLER) && hasTrait(device, TRAITS.MOTOR_SETTINGS)) {
    return SETTINGS_PATHS.MOTOR;
  }
  if (isType(device, DEVICE_TYPES.CURTAIN_MODULE) && hasTrait(device, TRAITS.CURTAIN_TRAVEL_TIME)) {
    return SETTINGS_PATHS.CURTAIN;
  }
  if (hasTrait(device, TRAITS.POWER_PROTECTION)) return SETTINGS_PATHS.COMMON;
  if (isType(device, DEVICE_TYPES.ENERGY_METER)) return SETTINGS_PATHS.METER;
  if (isModel(device, MODELS.WGRVC_2)) return SETTINGS_PATHS.VACUUM;
  if (isModel(device, MODELS.WZLTEG_1)) return SETTINGS_PATHS.SECURITY;
  return null;
};
